import { Button, TYPE_LINK } from '@eventbrite/eds-button';
import React, { FunctionComponent } from 'react';
import { TicketReseller } from '../../../models/tickets';

export type TicketResellerButtonProps = Pick<TicketReseller, 'url' | 'text'>;

export const TicketResellerButton: FunctionComponent<
    TicketResellerButtonProps
> = ({ url, text }) => {
    return (
        <div
            data-spec="show-ticket-reseller"
            data-testid="ticket-reseller-wrapper"
        >
            <Button
                data-spec="ticket-reseller-button"
                data-testid="ticket-reseller-button"
                href={url}
                role="button"
                target="eventResellerPage"
                type={TYPE_LINK}
            >
                {text}
            </Button>
        </div>
    );
};
